import axios from 'axios'
import { useAuthStore } from '../../stores/authStore'

// If BACKEND_API_URL is set, use it directly (dev server / production).
// If empty, use /api so the Vite dev proxy handles it (local Docker).
const BASE_URL = import.meta.env.BACKEND_API_URL
  ? `${import.meta.env.BACKEND_API_URL}/api`
  : '/api'

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
})

apiClient.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

apiClient.interceptors.response.use(
  (response) => {
    // Auto-unwrap DataResponse envelope: { data: T } → T
    // Only unwraps when "data" is the sole key (leaves PaginatedResponse intact).
    const d = response.data
    if (d !== null && typeof d === 'object' && Object.keys(d).length === 1 && 'data' in d) {
      response.data = d.data
    }
    return response
  },
  (error: unknown) => {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 401 && !error.config?.url?.includes('/auth/login')) {
        useAuthStore.getState().logout()
        window.location.href = '/signin'
      }
      // Replace Axios's generic "Request failed with status code NNN" with
      // the backend's human-readable message so every catch block just uses err.message.
      const backendMessage = error.response?.data?.message
      if (backendMessage) {
        return Promise.reject(new Error(backendMessage))
      }
    }
    return Promise.reject(error)
  }
)

export default apiClient
